export const CURRENCY = 'eur'
